if (!customElements.get('sticky-add-to-cart-bar')) {
  class StickyAddToCartBar extends HTMLElement {
    connectedCallback() {
      this.sourceButton = document.getElementById(this.dataset.sourceButtonId);
      this.mirrorButton = this.querySelector('button');
      if (!this.sourceButton || !this.mirrorButton) return;

      this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        requestAnimationFrame(() => {
          this.classList.toggle('is-shown', this.classList.contains('is-visible'));
        });
      });
      this.observer.observe(this.sourceButton);

      this.mutationObserver = new MutationObserver(() => this.syncState());
      this.mutationObserver.observe(this.sourceButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });
      this.syncState();
    }

    syncState() {
      this.mirrorButton.disabled = this.sourceButton.disabled;
      const sourceLabel = this.sourceButton.querySelector('span');
      const mirrorLabel = this.mirrorButton.querySelector('span');
      if (sourceLabel && mirrorLabel) mirrorLabel.textContent = sourceLabel.textContent;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutationObserver?.disconnect();
    }
  }

  customElements.define('sticky-add-to-cart-bar', StickyAddToCartBar);
}
